// トップページのカルーセル（sections/swiper.liquid）。自動切り替えと速度はテーマエディタの設定を data 属性で受け取る
(function () {
  var el = document.getElementById('bullets');
  if (!el || typeof Swiper === 'undefined') return;
  var autoplay = el.dataset.autoplay === 'true'
    ? { delay: parseInt(el.dataset.speed, 10) || 5000, disableOnInteraction: false }
    : false;

  new Swiper(el, {
    slidesPerView: 3,
    loop: true,
    autoplay: autoplay,
    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      type: 'bullets',
      clickable: true,
    },
  });
})();
